<template>
  <div style="width: 520px;">
    <q-form @submit="onSubmit" class="form-1c">
      <div class="form-1c__row">
        <label class="form-1c__label">Материал</label>
        <div class="form-1c__field form-1c__field--readonly">
          {{ row?.material_name || '—' }}
        </div>
      </div>

      <div class="form-1c__row">
        <label class="form-1c__label">Новое количество <span class="required">*</span></label>
        <div class="form-1c__field">
          <CustomInput
            placeholder="0"
            type="number"
            :required="true"
            :allowNegative="false"
            :value="materialCntValue"
            :suffix="row?.sell_unit_name || ''"
            @change_input="(value) => onChange(value)"
          />
          <div class="form-1c__hint">
            Количество можно менять только если есть накладная. Новое значение должно быть равно количеству в накладной.
          </div>
        </div>
      </div>

      <CustomModalFooter :btn-loading="loading" />
    </q-form>
  </div>
</template>

<script>
import CustomInput from "@/components/form/CustomInput";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import { updateEntranceMaterialRequestQty } from "@/views/ResidentialSettings/services";
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";

export default {
  name: "EditMaterialRequestQty",
  components: { CustomInput, CustomModalFooter },
  props: {
    data: { type: Object, required: true },
    closeModal: { type: Function, required: true },
  },
  data() {
    return {
      loading: false,
      formData: {
        material_cnt: null,
      },
    };
  },
  setup() {
    const { showErrorSnackbar, showSucceedSnackbar } = useCustomSnackbar();
    return { showErrorSnackbar, showSucceedSnackbar };
  },
  computed: {
    row() {
      return this.data?.data?.row || null;
    },
    params() {
      return this.data?.data?.params || null;
    },
    materialCntValue() {
      const v = this.formData.material_cnt;
      if (v === 0) return "0";
      return v == null ? "" : String(v);
    },
  },
  methods: {
    onChange(value) {
      this.formData.material_cnt = value;
    },
    async onSubmit() {
      const provider_request_item_id = this.row?.provider_request_item_id;
      const raw = this.formData.material_cnt;
      const material_cnt = raw === "" || raw == null ? null : Number(raw);

      if (!provider_request_item_id) {
        showErrorSnackbar("Не найден provider_request_item_id");
        return;
      }
      if (material_cnt == null || Number.isNaN(material_cnt) || material_cnt <= 0) {
        showErrorSnackbar("Введите корректное количество (> 0)");
        return;
      }

      this.loading = true;
      try {
        const res = await updateEntranceMaterialRequestQty(
          this.params,
          provider_request_item_id,
          material_cnt
        );
        if (this.data?.data?.onSubmit) {
          this.data.data.onSubmit(res);
        }
        this.showSucceedSnackbar("Количество обновлено");
        this.closeModal();
      } catch (e) {
        const msg =
          e?.response?.data?.message ||
          e?.response?.data?.error ||
          e?.message ||
          "Ошибка изменения количества";
        this.showErrorSnackbar(msg);
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.formData.material_cnt = this.row?.material_cnt ?? null;
  },
};
</script>
